// ------- MOCK DATA (frontend-only phase) -------
// All of this will be replaced by real backend data later.

export const IMAGES = {
  logo: "/img/logo.webp",
  heroHome: "/img/hero-home.webp",
  racingCard: "/img/racing-card.webp",
  teamCard: "/img/team-card.webp",
  testimonialBg: "/img/testimonial-bg.webp",
  heroRacing: "/img/hero-racing.webp",
  morningExercise: "/img/morning-exercise.webp",
  bloodstock: "/img/bloodstock.webp",
  heroTeam: "/img/hero-team.webp",
  adam: "/img/adam.webp",
  rebecca: "/img/rebecca.webp",
  news1: "/img/news1.webp",
  news2: "/img/news2.webp",
  racing1: "https://images.unsplash.com/flagged/photo-1569319388901-605a6d2d1299?w=1200&q=80",
  racing2: "https://images.unsplash.com/photo-1526094633853-031707a44819?w=1200&q=80",
  racing3: "https://images.unsplash.com/photo-1507514604110-ba3347c457f6?w=1200&q=80",
  racing4: "https://images.pexels.com/photos/17651070/pexels-photo-17651070.jpeg?w=1200&q=80",
  racing5: "https://images.pexels.com/photos/27981630/pexels-photo-27981630.jpeg?w=1200&q=80",
  thoroughbred1: "https://images.unsplash.com/photo-1516673699707-4f2a243fafaf?w=1200&q=80",
  thoroughbred2: "https://images.unsplash.com/photo-1573751056139-2ab65b6b03be?w=1200&q=80",
  stable: "https://images.unsplash.com/photo-1576692192914-9abed71b3ef9?w=1200&q=80",
};

export const TESTIMONIALS = [
  {
    quote: "Adam Driver provides a service and team that utilizes all aspects of sports medicine, technology and data analysis to produce outstanding results for his clients, both on the racecourse and on the stud farm. The attention to detail, clarity of communication and focused approach is excellent. I cannot recommend the services of Global Equine Group highly enough.",
    name: "Mr Thomas Muller",
    role: "Professional Footballer & Racehorse Owner",
  },
  {
    quote: "Adam Driver, together with his team at Global Equine Group, provide a refreshing new concept catering to all the needs of patrons wishing to own and breed racehorses, from initial purchase, throughout their racing career and retirement for breeding or sale. Global Equine Group are not only providing the maximum enjoyment of owning thoroughbred horses, but protecting the owner's interests and saving them money.",
    name: "Marco Botti",
    role: "Racehorse Trainer",
  },
];

export const TEAM = [
  {
    id: "team-1",
    name: "Adam Driver",
    role: "Managing Director",
    image: "/img/adam.webp",
    bio: [
      "The company is the brain-child of Adam Driver, an experienced equine veterinarian, based in Newmarket, England.",
      "Adam's work has taken him around the world and amongst others, he has performed work for Godolphin Management Company Ltd, Dubai Equine Hospital and Shadwell Management Company Ltd. Adam has brought together some of the most experienced individuals in the industry to create the Global Equine Group team.",
      "Global Equine Group has extensive experience working for clients globally, and has acted on behalf of clients in many countries from Argentina to South Africa; Qatar to the USA, managing and providing a consultant service for client's horses. The company has built up a network of dependable, trustworthy professionals within the equine industry, and knows how to get things done, no matter how big or small the challenge. Currently, Global Equine Group has clients and horses under management in 6 continents worldwide.",
      "By harnessing the latest technology with this professional team we aim to provide a whole new approach that will not only put our client's interests first, but aim to keep costs down and provide value for money in all areas of the industry.",
    ],
  },
  {
    id: "team-2",
    name: "Rebecca Hegarty",
    role: "Assistant Racing Manager",
    image: "/img/rebecca.webp",
    bio: [
      "Rebecca has worked for Global Equine Group for 10 years. Prior to this Rebecca spent 7 years working for the Derby winning racehorse trainer, Peter Chapple-Hyam in Newmarket where her responsibilities included running the equine spa and as a travelling head lad at the races, saddling horses, liaising with the owners, trainer and jockey.",
      "Rebecca was also employed for 10 years working for the multiple Classic winning racehorse trainer, Sir Henry Cecil. Rebecca had a senior head lad role in the yard, with responsibilities including riding out with the string every morning, watching the work and helping to ensure the safety of the horses going out and exercising on the Newmarket Heath.",
      "Altogether, Rebecca has nearly two decades of experience at a senior level, working with some of the best racehorses and trainers in the country. With this level of experience she has applied her skill-set to the racing and bloodstock management at Global Equine Group, integrating successfully into the company to become a valued and knowledgeable member of staff.",
    ],
  },
  {
    id: "team-3",
    name: "Elbashir Elhrari",
    role: "Racing Manager – MENA Region",
    image: "https://images.unsplash.com/photo-1573751056139-2ab65b6b03be?w=1200&q=80",
    bio: [
      "Bashir is the Global Equine Group Racing Manager for the Middle East and North Africa region (MENA).",
      "Fluent in Arabic and English, Bashir has a life-long passion for racehorses, and has been involved in racing, owning and riding horses for decades, with personal interests in horses in the UK, France, Dubai, Tunisia, Libya and Morocco.",
      "Through his own involvement in racehorse ownership, Bashir has built up an enviable library of knowledge and skills in buying and managing racehorses, with a unique insight into the challenges and requirements for the Middle Eastern owner. Using this experience Bashir is able to service all of the requirements for our MENA clients and help them navigate the journey into racehorse ownership.",
    ],
  },
];

export const STATS = [
  { value: 6, suffix: "", label: "Continents Worldwide" },
  { value: 20, suffix: "+", label: "Countries Served" },
  { value: 15, suffix: "+", label: "Years of Expertise" },
  { value: 100, suffix: "+", label: "Winners Managed" },
];

